import { ApiBaseCall } from "utils/apiCall";

// QUERY - Return data but don't change the state
export async function getListingDetail(id) {
  const endpoint = `/shared/listings/${id}`;
  return await ApiBaseCall.get(endpoint);
}
